import { Reducer } from "redux";

import { ForumReadFeedTriggerAction } from "@/mk2/apps/forum/actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import infiniteList, {
    State as InfiniteListState,
    initialState as initialInfiniteListState,
} from "@/mk2/reducers/infiniteList";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

import {
    CONTESTS_HOME_FETCH_FAILURE,
    CONTESTS_HOME_FETCH_REQUEST,
    CONTESTS_HOME_FETCH_SUCCESS,
    CONTESTS_HOME_SET_FOLLOWING_API_FAILURE,
    CONTESTS_HOME_SET_FOLLOWING_API_REQUEST,
    CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS,
    ContestsHomeFetchFailureAction,
    ContestsHomeFetchRequestAction,
    ContestsHomeFetchSuccessAction,
    ContestsHomeSetFollowingApiFailureAction,
    ContestsHomeSetFollowingApiRequestAction,
    ContestsHomeSetFollowingApiSuccessAction,
} from "./ContestsHome.actions";

export interface ContestsHomePageState extends InfiniteListState {
    runningContests: number[];
    hasMore: boolean;
    isFollowing: boolean;
    setFollowingLoadingState: LoadingState;
    setFollowingErrorMessage: string;
    drafts: number[];
}

export const initialContestsHomePageState: ContestsHomePageState = {
    ...initialInfiniteListState,
    runningContests: [],
    hasMore: false,
    isFollowing: false,
    setFollowingLoadingState: LoadingState.INIT,
    setFollowingErrorMessage: null,
    drafts: null,
};

const contestsHomePostsReducer = infiniteList<
    ContestsHomeFetchRequestAction,
    ContestsHomeFetchSuccessAction,
    ContestsHomeFetchFailureAction
>("CONTESTS_HOME_FETCH", (a) => a.response.result.finishedContests);

type IsFollowingReducerActions =
    | ContestsHomeFetchSuccessAction
    | ContestsHomeSetFollowingApiFailureAction
    | ContestsHomeSetFollowingApiRequestAction
    | ContestsHomeSetFollowingApiSuccessAction;

const isFollowingReducer = (state = false, action: IsFollowingReducerActions) => {
    switch (action.type) {
        case CONTESTS_HOME_FETCH_SUCCESS:
            return action.isFollowing;

        case CONTESTS_HOME_SET_FOLLOWING_API_FAILURE:
            return !action.value;

        case CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS:
            return action.response.result.isFollowing;

        default:
            return state;
    }
};

type ContestsHomePageReducerActions =
    | ContestsHomeFetchRequestAction
    | ContestsHomeFetchSuccessAction
    | ContestsHomeFetchFailureAction
    | ContestsHomeSetFollowingApiFailureAction
    | ContestsHomeSetFollowingApiRequestAction
    | ContestsHomeSetFollowingApiSuccessAction
    | ForumReadFeedTriggerAction;

const contestsHomePageReducer: Reducer<ContestsHomePageState, ContestsHomePageReducerActions> = (
    state = initialContestsHomePageState,
    action,
) => {
    switch (action.type) {
        case CONTESTS_HOME_FETCH_REQUEST:
        case CONTESTS_HOME_FETCH_FAILURE:
            return tupdate(state, {
                ...contestsHomePostsReducer(state, action),
            });

        case CONTESTS_HOME_FETCH_SUCCESS:
            return tupdate(state, {
                ...contestsHomePostsReducer(state, action),
                runningContests: action.response.result.runningContests,
                drafts: action.response.result.draftContests,
                hasMore: action.hasMore,
                isFollowing: isFollowingReducer(action.isFollowing, action),
            });

        case CONTESTS_HOME_SET_FOLLOWING_API_FAILURE:
        case CONTESTS_HOME_SET_FOLLOWING_API_REQUEST:
        case CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS:
            return tupdate(state, {
                setFollowingLoadingState: loadingState(state.setFollowingLoadingState, action),
                setFollowingErrorMessage: errorMessage(state.setFollowingErrorMessage, action),
                isFollowing: isFollowingReducer(state.isFollowing, action),
            });

        default:
            return state;
    }
};

export default contestsHomePageReducer;
